export default {
  downtimeUrl: "https://id.kodland.tech",
  startPage: {
    image: "/welcome/quiz_indo_certificate.png",
    title: "Jawablah 5 pertanyaan dan dapatkan pelajaran GRATIS untuk anak anda",
    subtitle:
      "Klik Mulai 🚀 untuk melengkapi pembelajaran dan dapatkan sertifikat di kreativitas digital",
    button: "Mulai 🚀",
  },
  successPage: {
    title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS 🚀",
    subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
    button: "📆 Pesan",
  },
  quizRotateBySteps: {
    1: {
      question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
        "⛹️ Ya. Kegiatan olahraga",
        "🎨 Ya. Kelas seni",
        "💻 Ya. Kelas koding dan ilmu komputer",
        "🏕️ Ya. Pramuka",
        "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
      ],
    },
    2: {
      question: "Apa mata pelajaran kesukaan anak Anda?",
      answers: [
        "🔬 Sains",
        "🎨 Seni dan desain",
        "💻 Ilmu komputer",
         "🏛️ Ilmu budaya (Sejarah, Literasi, dsb.)",
        "📐 Matematika",
        "💬 Ilmu Bahasa",
        "🤩 Semua yang di atas",
      ],
    },
    3: {
      question: "Bagaimana biasanya anak Anda menghabiskan waktu luangnya?",
      answers: [
        "📱 Bermain game di HP atau komputer",
        "👽 Menonton kartun",
        "♟️ Bermain permainan papan",
        "👨‍👩‍👧‍👦 Menghabiskan waktunya dengan keluarga",
        "👥 Menghabiskan waktunya dengan teman",
        "⛹️ Bermain kegiatan olahraga",
        "🎨 Melakukan aktivitas seni: menggambar, musik, akting, dsb.",
      ],
    },
  },
};


